(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Fee', Fee);

    Fee.$inject = ['$resource'];

    function Fee ($resource) {
        var resourceUrl =  'api/fees/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
